import {
  FeaturesReady,
  GrowthBookProvider,
} from '@growthbook/growthbook-react';
import { useTranslation } from '@gympass/i18n';
import { useEffect } from 'react';

import { PageSkeleton } from 'components/templates/PageSkeleton';
import type { GrowthBookApp } from 'services/growthbook';
import { updateAttributes } from 'utils/experimentation';

const GROWTHBOOK_DEFAULT_TIMEOUT = 4 * 1000;

type GrowthbookAppProviderProps = {
  growthbook: GrowthBookApp;
  children: React.ReactNode;
};

export function GrowthbookAppProvider({
  children,
  growthbook: gb,
}: Readonly<GrowthbookAppProviderProps>) {
  const { i18n } = useTranslation();

  useEffect(
    function syncLanguageWithGbAttributes() {
      updateAttributes({
        growthbook: gb,
        attributes: {
          accept_language: i18n.language,
        },
        source: 'growthbook_app_provider_language_sync',
      });
    },
    [i18n.language, gb],
  );

  return (
    <GrowthBookProvider growthbook={gb}>
      <FeaturesReady
        timeout={GROWTHBOOK_DEFAULT_TIMEOUT}
        fallback={<PageSkeleton />}
      >
        {children}
      </FeaturesReady>
    </GrowthBookProvider>
  );
}
